<h1 mat-dialog-title class="p-2 text-center" i18n>Ajout d'un utilisateur </h1>
<div mat-dialog-content class="p-3">

    <div class="row">
        <mat-form-field class="col">
            <input matInput [(ngModel)]="Model.Email" i18n-placeholder placeholder="Email" [formControl]="ValidEmail" [disabled]="!IsCreation" required>
            @if (!ValidEmail.valid) {
                <mat-error i18n>
                    Email incorrect
                </mat-error>
            }
        </mat-form-field>
        <div class="col-auto">
            <button appPreventDoubleClick class="col h-75" color="primray" mat-raised-button (throttledClick)="search()" [disabled]="!ValidEmail.valid" i18n>
                Rechercher
            </button>
        </div>
    </div>
    <div class="row">
        <mat-form-field class="col">
            <input matInput [(ngModel)]="Model.FirstName" i18n-placeholder placeholder="Prénom" required>
        </mat-form-field>
    </div>
    <div class="row">
        <mat-form-field class="col">
            <input matInput [(ngModel)]="Model.LastName" i18n-placeholder placeholder="Nom" required>
        </mat-form-field>
    </div>
    <div class="row">
        <mat-form-field class="col">
            <mat-select i18n-placeholder placeholder="Profil Utilisateur" [(ngModel)]="Model.Type">
                @for (type of UserTypeList; track type.idx) {
                <mat-option [value]="type.idx">
                    <span>{{type.s}} </span>
                </mat-option>
                }
            </mat-select>
        </mat-form-field>
    </div>
    <div class="row">
        <mat-slide-toggle [(ngModel)]="Model.IsActive" i18n> Actif</mat-slide-toggle>
    </div>

    <div class="row mt-3 g-0">
        <button appPreventDoubleClick class="col me-1" color="basic" mat-stroked-button (throttledClick)="onCancel()" i18n>
            Annuler
        </button>
        <button appPreventDoubleClick class="col ms-1" color="accent" mat-raised-button (throttledClick)="onConfirm()" [disabled]="!CanSave()" i18n>
            Ajouter
        </button>
    </div>
</div>